import { render, staticRenderFns } from "./LiberdadeCampanhas.vue?vue&type=template&id=6339d8f3&scoped=true"
import script from "./LiberdadeCampanhas.vue?vue&type=script&lang=js"
export * from "./LiberdadeCampanhas.vue?vue&type=script&lang=js"
import style0 from "./LiberdadeCampanhas.vue?vue&type=style&index=0&id=6339d8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6339d8f3",
  null
  
)

export default component.exports